import Axios from 'axios';
import { useMutation } from '@tanstack/vue-query';

export default function useUpdateCartQuantityMutation() {
  return useMutation({
    mutationFn: ({ itemId, quantity }) => Axios.put(`/api/cart/item/${itemId}`, { quantity }),
  });
}
